<template>
  <div v-if="tag === 'div'" class="input" :class="getLine">
    <slot></slot>
    <textarea v-if="type === 'textarea'" :class="[getAlign, color]" :type="type" :placeholder="placeholder" :value="text" :readonly="readonly" @keydown="inputKeyDownHandler" @focus="$emit('focus', $event)"  @focusout="$emit('focusout', $event)" @input="updateInput" :pattern="getPattern"/>
    <input v-else :class="[getAlign, color]" :type="type" :placeholder="placeholder" :value="text" @input="updateInput" :readonly="readonly" @keydown="inputKeyDownHandler" @focus="$emit('focus', $event)" @focusout="$emit('focusout', $event)" :pattern="getPattern"/>
    <slot name="last"></slot>
  </div>
  <li v-else-if="tag === 'li'" class="input" :class="getLine">
    <slot></slot>
    <textarea v-if="type === 'textarea'" :class="[getAlign, color]" :type="type" :placeholder="placeholder" :value="text" @input="updateInput" :readonly="readonly" @keydown="inputKeyDownHandler" @focus="$emit('focus', $event)" @focusout="$emit('focusout', $event)" :pattern="getPattern"/>
    <input v-else :class="[getAlign, color]" :type="type" :placeholder="placeholder" :value="text" @input="updateInput" :readonly="readonly" @keydown="inputKeyDownHandler" @focus="$emit('focus', $event)" @focusout="$emit('focusout', $event)" :pattern="getPattern"/>
    <slot name="last"></slot>
  </li>
</template>

<script>
export default {
  props: {
    placeholder: { type: String },
    type: { type: String, default: 'text' },
    state: {type: String, default: 'base'},
    value: {type: String},
    tag: { type: String, default: 'div' },
    line: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    onlynumber: {type: Boolean, default: false},
    align: { type: String, default: 'left' },
    auto: { type: Boolean, default: false },
    limit: {type: Number, default: -1},
    minHeight: {type: Number, default: 25},
    pattern: {type: String, default: ''},
    color: {type: String, default: 'base'},
    limitHeight: {type: Number}
  },
  create () {
  },
  mounted () {
    this.text = this.value
    if (this.$el.querySelector('textarea')) {
      console.log(this.$el.querySelector('textarea'))
      setTimeout(() => {
        this.inputChange({target: this.$el.querySelector('textarea')})
      })
    }
  },
  data: function () {
    return {
      text: ''
    }
  },
  name: 'Uinput',
  watch: {
    value (val) {
      console.log('Uinput value', val)
      this.text = val
    }
  },
  methods: {
    updateInput (e) {
      var val = e.target.value
      this.text = val
      // console.log('updateInput',val.length, this.limit , val.length > this.limit, this.limit > 0 && val.length > this.limit)
      if (this.limit > 0 && val.length > this.limit) {
        console.log('updateInput', val.length, this.limit)
        this.text = val.substring(0, this.limit)
      }
      if (this.$el.querySelector('textarea')) {
        setTimeout(() => {
          this.inputChange({target: this.$el.querySelector('textarea')})
        })
      }
      if (this.onlynumber) {
        this.text = val.replace(/[^0-9]/g, '')
      }
      this.$emit('update:value', this.text)
      this.$emit('input', this.text)
      // this.$emit('input', this.text)
    },
    inputKeyDownHandler (e) {
      console.log('uinput inputKeyDownHandler', e.keyCode, e.which, this.type)
      switch (e.keyCode || e.which) {
        // enter
        case 13 :
          switch (this.type) {
            case 'text':
            case 'password':
            case 'email':
              this.$emit('enter')
              break
          }
          break
        // esc
        case 27 :
          this.$emit('esc')
          break
      }
    },
    inputChange (e) {
      console.log(e, e.target.scrollHeight)
      if (this.limitHeight) {
        e.target.style.height = '1px'
        if (e.target.scrollHeight < this.limitHeight) {
          e.target.style.height = Math.max(e.target.scrollHeight, this.minHeight) + 'px'
        } else {
          e.target.style.height = (this.limitHeight) + 'px'
        }
      } else {
        e.target.style.height = '1px'
        e.target.style.height = Math.max(e.target.scrollHeight, this.minHeight) + 'px'
      }
      console.log(e.target.style, e.target.value)
      this.$emit('input', e.target.value)
    }
  },
  computed: {
    getAlign () {
      return 'text_' + this.align
    },
    getPattern () {
      switch (this.pattern) {
        case '' :
          return undefined
        default :
          return this.pattern
      }
    },
    getLine () {
      switch (this.line) {
        case '' :
          return undefined
        default :
          return 'line_' + this.line
      }
    }
  }
}
</script>

<style scoped>
.input {
  display: flex;
  align-items: center;
}
.input.line_bottom {
  border-bottom: 1px solid var(--line-base);
}
.input.line_top {
  border-top: 1px solid var(--line-base);
}
.input.line_left {
  border-left: 1px solid var(--line-base);
}
.input.line_right {
  border-right: 1px solid var(--line-base);
}
.input.line_box {
  border: 1px solid var(--line-base);
}
.input input.text_left {
  text-align: left;
}
.input input.text_center {
  text-align: center;
}
.input input.text_right {
  text-align: right;
  padding-right: 20px;
}
.input input {
  /* color: var(--text-base); */
  padding-left: 5px;
  padding-right: 5px;
}
.input input:read-only {
  background-color: var(--disable);
}
.input input::placeholder {
  color: var(--text-guide);
}
.input textarea.text_left {
  text-align: left;
}
.input textarea.text_center {
  text-align: center;
}
.input textarea.text_right {
  text-align: right;
}
.input textarea {
  color: var(--text-base);
  height: 19px;
  margin: 10px 0px;
}
.input textarea::placeholder {
  color: var(--text-guide);
}
</style>



// WEBPACK FOOTER //
// src/components/base/UInput.vue